import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { ContentUnavailableErrorScreen } from '../components/Errors'

// Public routes that are not protected by the authentication
export default function PublicNavigation() {
  return (
    <Routes>
      <Route
        path="/content_unavailable"
        element={<ContentUnavailableErrorScreen fill="#005eb8" />}
      />
    </Routes>
  )
}

// Public routes list
export const publicRoutes = [
  '/content_unavailable',
]